// Traduzioni EN della pagina Contabilità (billing) del manager.
// Pattern gettext: la STRINGA ITALIANA è la chiave.
const m = {
  // ── Breadcrumb / titoli ──
  'Home': 'Home',
  'Fatture': 'Invoices',
  'Transazioni effettuate': 'Transactions',
  'Ordini': 'Orders',
  'Da pagare': 'To pay',
  'Rinnovo': 'Renewal',
  'Metodi di pagamento': 'Payment methods',
  'Impostazioni di fatturazione': 'Billing settings',

  // ── Banner metodo di pagamento ──
  'Aggiungi una modalità di pagamento': 'Add a payment method',
  'Aggiungere un metodo di pagamento per garantire il rinnovo automatico dei tuoi prodotti ed evitare interruzioni del servizio.': 'Add a payment method to ensure automatic renewal of your products and avoid service interruptions.',

  // ── Paginazione ──
  'Risultati per pagina': 'Results per page',
  'Pagina 1 di 1': 'Page 1 of 1',

  // ── Comuni ──
  'Caricamento…': 'Loading…',
  'Aggiungere un filtro': 'Add a filter',
  'Gratuito': 'Free',
  'Metodo di pagamento': 'Payment method',
  'Totale (TTC)': 'Total (incl. tax)',
  'CERCARE...': 'SEARCH...',

  // ── Fatture ──
  'Fattura': 'Invoice',
  'Pagare le fatture in sospeso': 'Pay outstanding invoices',
  'Cercare un prodotto, un numero di fattura': 'Search for a product or an invoice number',
  'Nessuna fattura': 'No invoices',
  'N° della fattura': 'Invoice no.',
  'Data di creazione': 'Creation date',
  'Statuto': 'Status',
  'Prodotti / Servizi': 'Products / Services',
  'Pagare la fattura': 'Pay the invoice',

  // ── Transazioni ──
  'Transazione effettuata': 'Transaction',
  'Cercare un n° di transazione': 'Search for a transaction no.',
  'Nessuna transazione': 'No transactions',
  'N° del pagamento': 'Payment no.',
  'Pagato il': 'Paid on',
  'Documenti': 'Documents',
  '1 documento': '1 document',

  // ── Ordini ──
  'Tutti gli stati': 'All statuses',
  'Tutti i servizi': 'All services',
  'Mostra soltanto gli ordini dei partner': 'Show only partner orders',
  'Nessun ordine': 'No orders',
  'Numero': 'Number',
  'Data': 'Date',
  'Stato': 'Status',
  'Tipo': 'Type',
  'Partner': 'Partner',
  'Importo (tasse incluse)': 'Amount (tax included)',
  'Ordine di nuovi prodotti': 'Order of new products',

  // ── Da pagare ──
  'I prossimi 7 giorni': 'The next 7 days',
  'I prossimi 15 giorni': 'The next 15 days',
  'Il prossimo mese': 'Next month',
  'I prossimi 2 mesi': 'The next 2 months',
  'I prossimi 3 mesi': 'The next 3 months',
  'Tutto': 'All',
  'Tutti i tipi': 'All types',
  'Servizi': 'Services',
  'Elementi': 'Items',
  'Etichetta': 'Label',
  'Scadenza': 'Expiry',
  'Importo (Tasse escluse)': 'Amount (tax excluded)',
  '(G{sign}{n})': '(D{sign}{n})',
  'Nessun risultato trovato per questi criteri': 'No results found for these criteria',
  'Prodotti o fatture scaduti': 'Expired products or invoices',
  'Scade tra 14 giorni o meno': 'Expires in 14 days or less',
  'Domini ripristinabili': 'Restorable domains',
  'IVA': 'VAT',
  'Importo (Tasse incluse)': 'Amount (tax included)',
  'Generare una fattura pro forma': 'Generate a pro forma invoice',
  'Pagare la mia selezione': 'Pay my selection',

  // ── Rinnovo ──
  'Semplificati la vita e lascia che NeoFlux rinnovi i tuoi prodotti alla loro scadenza. Hai la certezza di non perdere mai i tuoi prodotti per errore. Potrai modificare le tue preferenze in qualsiasi momento.': 'Make your life easier and let NeoFlux renew your products upon expiry. You can be sure you will never lose your products by mistake. You can change your preferences at any time.',
  'Per più informazioni': 'For more information',
  'Renewal Warranty: assicurati di mantenere i tuoi prodotti, anche in caso di problemi!': 'Renewal Warranty: make sure you keep your products, even in case of problems!',
  'Gestire i rinnovi ▾': 'Manage renewals ▾',
  'Filtri ▾': 'Filters ▾',
  'Rinnovo automatico': 'Automatic renewal',
  'Attivato': 'Enabled',
  'Disattivato': 'Disabled',
  'Nessun risultato trovato per questi criteri.': 'No results found for these criteria.',
  'Gestire i miei profili di pagamento': 'Manage my payment profiles',

  // ── Metodi di pagamento ──
  'CARTA': 'CARD',
  'Imposta come predefinito': 'Set as default',
  'Pagamento predefinito': 'Default payment',
  'Elimina metodo': 'Delete method',
  'Nessuna modalità di pagamento registrata': 'No payment method saved',
  'Gestisci i metodi di pagamento che utilizzi per rinnovare i tuoi prodotti e pagare le fatture.': 'Manage the payment methods you use to renew your products and pay your invoices.',
  'Metodi di pagamento registrati': 'Saved payment methods',
  'Conto prepagato': 'Prepaid account',
  'Ricarica il tuo conto prepagato': 'Top up your prepaid account',
  'Saldo del conto :': 'Account balance:',
  'Carica credito sul conto': 'Add credit to the account',
  'Cronologia delle operazioni': 'Transaction history',
  'Cronologia delle operazioni vuota': 'Transaction history is empty',
  'Al momento non hai registrato nessuna operazione': 'You have not recorded any transactions yet',
  'Descrizione': 'Description',
  'Importo': 'Amount',
  'Eliminare la carta •••• {cifre}?': 'Delete the card •••• {cifre}?',

  // ── Impostazioni di fatturazione ──
  'Indirizzi di fatturazione': 'Billing addresses',
  'Aggiungere un indirizzo di fatturazione': 'Add a billing address',
  'Aggiungi e gestisci i tuoi indirizzi di fatturazione per semplificare i tuoi ordini.': 'Add and manage your billing addresses to simplify your orders.',
  'Indirizzo predefinito': 'Default address',
  'Modificare': 'Edit',
  'Emissione delle fatture': 'Invoice issuance',
  'Includi le fatture in PDF nelle e-mail': 'Include PDF invoices in e-mails',
  'Ricevi le fatture in formato PDF come allegati alle tue e-mail legate alla fatturazione.': 'Receive your invoices in PDF format as attachments to your billing-related e-mails.',
  'Riferimento della fattura': 'Invoice reference',
  'Questo riferimento comparirà su tutte le fatture che ti emetteremo.': 'This reference will appear on all invoices we issue to you.',
  'Aggiungere un riferimento': 'Add a reference',
  'Notifiche': 'Notifications',
  '1 utente': '1 user',
  'della tua organizzazione riceverà le seguenti notifiche:': 'of your organization will receive the following notifications:',
  'Nuova fattura': 'New invoice',
  'Ricevi una e-mail quando viene emessa una nuova fattura.': 'Receive an e-mail when a new invoice is issued.',
  'Data di scadenza': 'Expiry date',
  'Ricevi una e-mail promemoria prima della data di scadenza del rinnovo automatico di un prodotto (14 giorni prima della scadenza).': 'Receive a reminder e-mail before the expiry date of a product’s automatic renewal (14 days before expiry).',
  'Addebito automatico': 'Automatic charge',
  "Ricevi una e-mail di conferma dell'addebito automatico.": 'Receive a confirmation e-mail for the automatic charge.',

  // ── Dialogo indirizzo ──
  'Modificare l’indirizzo di fatturazione': 'Edit billing address',
  'Chiudi': 'Close',
  'Tipo di cliente': 'Customer type',
  'Ragione sociale': 'Company name',
  'Nome': 'First name',
  'Cognome': 'Last name',
  'Prefisso': 'Prefix',
  'Telefono': 'Phone',
  'Indirizzo': 'Address',
  'Complemento (facoltativo)': 'Additional info (optional)',
  'CAP': 'Postal code',
  'Città': 'City',
  'Provincia': 'Province',
  'Nazione': 'Country',
  'Codice Fiscale (ente/azienda)': 'Tax code (entity/company)',
  'Codice Fiscale': 'Tax code',
  'Partita IVA': 'VAT number',
  'Partita IVA comunitaria (UE — VIES)': 'EU VAT number (EU — VIES)',
  'Codice fiscale / Tax ID (estero)': 'Tax code / Tax ID (foreign)',
  'Codice destinatario (SDI)': 'Recipient code (SDI)',
  'PEC': 'Certified e-mail (PEC)',
  'Annullare': 'Cancel',
  'Attendere…': 'Please wait…',
  'Convalidare': 'Confirm',
  'Salvataggio non riuscito.': 'Save failed.',
};

export default m;
